import { useTranslation } from 'react-i18next';

import { useSetWatching, useWatchState } from '@/entities/collab';
import { FormError } from '@/shared/forms';
import { AvatarStack, Button } from '@/shared/ui';

import { useCardAbilities } from './abilities';
import styles from './Collab.module.css';

/** Watch / unwatch the task and see who else watches it. */
export function WatchersControl({ cardId }: { cardId: string }) {
  const { t } = useTranslation();
  const { watch } = useCardAbilities();
  const state = useWatchState(cardId);
  const setWatching = useSetWatching(cardId);
  const watching = state.data?.watching ?? false;
  const people = (state.data?.watchers ?? []).map((w) => ({ id: w.user_id, name: w.display_name }));
  return (
    <div className={styles.row}>
      <h4 className={styles.rowTitle}>{t('watchers.title')}</h4>
      <div className={styles.watchLine}>
        <Button
          size="sm"
          aria-pressed={watching}
          disabled={setWatching.isPending || state.isPending || (!watching && !watch)}
          onClick={() => {
            setWatching.mutate(!watching);
          }}
        >
          {watching ? t('watchers.unwatch') : t('watchers.watch')}
        </Button>
        {people.length > 0 && (
          <AvatarStack people={people} size="sm" max={5} label={t('watchers.list')} />
        )}
      </div>
      <FormError error={setWatching.error} />
    </div>
  );
}
